<template>
  <div class="panel">
    <right-card :bg="'border5'">
      <v-title>气象站</v-title>
      <div class="content">
        <div class="flex-between target-box">
          <div
            class="target flex"
            v-for="(item, index) in targetList"
            :key="index"
            :style="{ top: item.top }"
          >
            <div class="barDiv">
              <div class="circles">
                <img :src="item.img" />
                <div class="circle-row" />
              </div>
              <div class="barTitle">{{ item.name }}</div>
              <div style="color: #0ff;">
                <span class="num">{{ item.value }}</span
                >{{ item.unit }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </right-card>
  </div>
</template>

<script>
import { findQxzWlwnNwestData } from "@/api/home";
export default {
  data() {
    return {
      targetList: [
        {
          name: "温度",
          value: "28.1",
          unit: "℃",
          img: require("images/index/szjc/wd.png"),
          top: "0%"
        },
        {
          img: require("images/index/szjc/rjy.png"),
          name: "湿度",
          value: "82",
          unit: "%",
          top: "-15%"
        },
        {
          name: "风速",
          value: "1.1",
          unit: "m/s",
          img: require("images/index/szjc/yd.png"),
          top: "0%"
        },
        {
          name: "雨量",
          value: "10.6",
          unit: "mm",
          img: require("images/index/szjc/zd.png"),
          top: "-15%"
        },
        {
          name: "气压",
          value: "963.6",
          unit: "hpa",
          img: require("images/index/szjc/ph.png"),
          top: "0%"
        }
      ]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      findQxzWlwnNwestData().then(res => {
        if (res.data.data) {
          const data = res.data.data.splice(0, 5);
          this.targetList = data.map((ele, index) => {
            return {
              name: ele.name,
              value: ele.value,
              unit: ele.unit,
              img: this.$config.imgWlw + ele.image_path,
              top: index % 2 === 0 ? "0%" : "-15%"
            };
          });
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.panel
  height calc(30% - 0px)
  font-size .06rem
  overflow hidden

.content
  height calc(100% - .2rem)
  text-align center
  position relative

.target-box
  position relative
  padding 5% .1rem
  height 100%
  width 100%
  box-sizing border-box

.target
  color #fff
  position relative
  text-align center
  font-size .065rem
  background  url('~images/index/szjc/sz_nav_bj.png') no-repeat center center,linear-gradient(to top, #063D4D, #011E2E)
  background-size 100% 100%
  height 100%
  width 16%
  flex-wrap wrap
  border-bottom-right-radius 0.04rem
  border-bottom-left-radius 0.04rem
.barTitle
  margin-top 0.04rem
.barDiv
  height 60%
  width 100%
  position relative

.circles
  padding 0.03rem
  position relative
  display inline-block

  img
    width .23rem
    vertical-align middle

  .circle-row
    position absolute
    top 0
    left 0
    height 100%
    width 100%
    background url('~images/index/szjc/circle.png') no-repeat center
    background-size 100% 100%
    animation rotation 8s linear infinite
    -moz-animation rotation 8s linear infinite
    -webkit-animation rotation 8s linear infinite
    -o-animation rotation 8s linear infinite

@keyframes rotation
  from
    -webkit-transform rotate(0deg)

  to
    -webkit-transform rotate(360deg)

.num
  font-size .11rem
  color $textColor
</style>
